// 简化的API服务，直接使用ApiClient
import { ApiClient, ApiClientConfig, createApiClient } from '../../entities';

// 全局 API 客户端实例
let globalApiClient: ApiClient | null = null;
let globalApiClientPromise: Promise<ApiClient> | null = null;

// 初始化 API 客户端
export const initApiClient = async (config: ApiClientConfig): Promise<ApiClient> => {
  // SSR 环境下为每个请求创建新实例，避免跨请求共享状态
  if (import.meta.server) {
    return createApiClient(config);
  }

  if (!globalApiClient) {
    globalApiClientPromise = createApiClient(config);
    globalApiClient = await globalApiClientPromise;
  }
  return globalApiClient;
};

// 获取 API 客户端实例
export const getApiClient = async (): Promise<ApiClient> => {
  if (globalApiClientPromise) {
    globalApiClient = await globalApiClientPromise;
  }
  if (!globalApiClient) {
    throw new Error('ApiClient not initialized. Call initApiClient first.');
  }
  return globalApiClient;
};

// 销毁 API 客户端实例（SSR 清理用）
export const destroyApiClient = async (): Promise<void> => {
  if (globalApiClient) {
    // ApiClient 有 destroy 方法用于清理拦截器
    if (typeof globalApiClient.destroy === 'function') {
      globalApiClient.destroy();
    }
    globalApiClient = null;
    globalApiClientPromise = null;
  }
};

// 导出类型和配置
export type { ApiClientConfig } from '../../entities';
